module.exports = __webpack_public_path__ + "img/lalanitahome1v_vtl_3.1ab9df54.webp";